import * as Yup from 'yup';

const VolumeDiscountSchema = Yup.object().shape({
  cost: Yup.number().required(),
  min_cases: Yup.number().required(),
});

export type VolumeDiscount = Yup.InferType<typeof VolumeDiscountSchema>;

export const ProductPricingSchema = Yup.object().shape({
  previous_cost: Yup.number(),
  current_cost: Yup.number(),
  future_cost: Yup.number(),

  previous_volume_discounts: Yup.array().of(VolumeDiscountSchema),
  volume_discounts: Yup.array().of(VolumeDiscountSchema),
  future_volume_discounts: Yup.array().of(VolumeDiscountSchema),
});
